import { CommonModule } from '@angular/common';
import {
  AfterContentInit,
  Component,
  ContentChild,
  DestroyRef,
  input,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  FormsModule,
  NgControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  getValidationTranslation,
  hasValidationError,
} from '@app/helpers/validation.helper';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'labeled-content',
  imports: [CommonModule, TranslateModule, FormsModule, ReactiveFormsModule],
  templateUrl: './labeled-content.component.html',
  styleUrl: './labeled-content.component.scss',
})
export class LabeledContentComponent implements AfterContentInit {
  @ContentChild(NgControl, { static: true }) formControl?: NgControl;

  for = input<string>();
  label = input.required<string>();
  validationLabel = signal<string>('validation.required');

  constructor(
    private translateService: TranslateService,
    private destroyRef: DestroyRef,
  ) {}

  protected hasError(): boolean | null {
    return hasValidationError(this.formControl);
  }

  protected isRequired(): boolean {
    return (
      this.formControl?.control?.hasValidator(Validators.required) ?? false
    );
  }

  ngAfterContentInit() {
    if (this.formControl?.control) {
      this.formControl.control.statusChanges
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          const errors = this.formControl?.errors;
          if (errors) {
            const newValidationTranslation = getValidationTranslation(
              this.translateService,
              this.formControl?.errors,
            );
            if (newValidationTranslation !== null) {
              this.validationLabel.set(newValidationTranslation);
            }
          }
        });
    }
  }
}
